import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Icon from '@app/src/common/components/Icon';

import './PasswordStrengthIndicator.scss';

export interface IPasswordStrengthIndicatorProps {
  checked: boolean;
  message: string;
}

const PasswordStrengthIndicator = ({
  checked,
  message
}: IPasswordStrengthIndicatorProps) => (
  <div className="password-indicator">
    <span
      className={classNames(
        'password-indicator__check',
        checked && 'password-indicator__check_active'
      )}
    >
      {checked && <Icon icon="checked" size="sm" />}
    </span>
    <FormattedMessage id={message} />
  </div>
);

export default PasswordStrengthIndicator;
